import * as React from 'react'
import { ExternalValueProps } from './LogPointsApplicationsBody/LogPointsApplicationsBody'
import { ExternalProps } from './LogPointsAPIsBody/LogPointsAPIsBody'
import { ReactNode } from 'react'
import LogPointsAPIsBody from './LogPointsAPIsBody/LogPointsAPIsBodyContainer'
import './LogPointsBody.css'
import LogPointsApplicationsBodyContainer from './LogPointsApplicationsBody/LogPointsApplicationsBodyContainer'

export const LOG_POINTS_BODIES = {
  api: (props: ExternalProps) => (<LogPointsAPIsBody {...props}/>),
  application: (props: ExternalValueProps) => (<LogPointsApplicationsBodyContainer {...props}/>)
}

export type ValueProps = {
  logPointsBody: ReactNode
}

export type Props = ValueProps

export const LogPointsBody = (props: Props) => (
  <div className="log-points-body">
    {props.logPointsBody}
  </div>
)
